import Util from '../../utils/utils'

//
// Main navigation
//
;(($) => {
    $(() => {
        let module = $('.main-navigation')
        let isLegacyNavigationActive = $('.site-header').hasClass('legacy-nav')

        // Only continue if module is on page
        if (!module.length) return

        if (isLegacyNavigationActive) {
            let toggle = $('.site-header .main-navigation-toggle button')
            let dropdown = module.find('.main-navigation-items .dropdown')
            let dropDownToggle = module.find('.main-navigation-items .collapse-toggle')

            toggle.click(() => {
                module.toggleClass('open')
            })

            // Click outside of main navigation
            $(document).on('click', (event) => {
                if (
                    !$(event.target).closest('.main-navigation > .container').length &&
                    !$(event.target).closest('.site-header .main-navigation-toggle button').length
                ) {
                    module.removeClass('open')
                }
            })

            // Mobile and Tablet dropdown functionality

            dropDownToggle.click(function (e) {
                if (Util.isMobile()) {
                    const thisDropDownToggle = $(this)
                    let dropdown = thisDropDownToggle.closest('li').find('.dropdown')

                    e.preventDefault()
                    dropdown.collapse('toggle')
                }
            })

            dropdown.on('hide.bs.collapse', function () {
                if (Util.isMobile()) {
                    $(this).closest('li').find('.collapse-toggle').addClass('collapsed')
                }
            })

            dropdown.on('show.bs.collapse', function () {
                if (Util.isMobile()) {
                    $(this).closest('li').find('.collapse-toggle').removeClass('collapsed')
                }
            })
        } else {
            let toggle = $('.site-header .main-navigation-toggle button')
            let slinkyMenu = module.find('.slinky-menu')
            let productsList = module.find('.menu-group.js-height')
            let mobileMenuFooter = module.find('.menu-footer')
            let menuItem = module.find('.menu-item')
            let body = $('body')
            let backdrop = body.find('.backdrop')
            let mobileMenu = null
            let desktopMenu = false

            // The deep submenu markup (grandchildren/great-grandchildren, and the top-level generic-page /
            // brands dropdowns) is kept out of the live DOM inside a <template> (see categories-navigation,
            // navigation-renderer and brands-navigation .html.twig) and cloned in on demand, since it's the
            // bulk of the mega-menu's DOM weight but only ever shown for one root-item/menu-item at a time.
            const hydrateSubmenu = (rootItem) => {
                const $rootItem = $(rootItem)
                const template = $rootItem.children('template.menu-products-submenu-template')[0]
                if (template && template.content.childNodes.length) {
                    // Replace the <template> in place (not appendChild) so the hydrated <ul> ends up
                    // as the immediate next sibling of the preceding <a> — Slinky.js wires up drill-down
                    // navigation via a strict `a + ul` adjacent-sibling selector, and a leftover empty
                    // <template> element sitting between them silently breaks that match.
                    template.replaceWith(template.content)
                    if (desktopMenu) {
                        setHeight(productsList)
                    }
                }
            }

            const hydrateAllSubmenus = () => {
                module.find('.root-item, .menu-item').each(function () {
                    hydrateSubmenu(this)
                })
            }

            // Maintain menu item hover state when scrollbar is enabled
            // Uses delegated events (not a direct .hover() binding) so hover still works on submenu content
            // that gets hydrated into the DOM after this handler is bound.
            // Scoped to .menu-products-submenu (the category-tree mega-menu only, categories-navigation.html.twig) —
            // navigation-renderer.html.twig / brands-navigation.html.twig reuse the same .submenu-items-group /
            // .submenu-items class names for their own arrow-click/collapse-controlled dropdown, and an unscoped
            // delegated selector here would force those open on hover too, bypassing the collapse-toggle click.
            const initMaintainHoverState = () => {
                module.on('mouseenter mouseleave', '.root-item', function () {
                    hydrateSubmenu(this)
                    $('.menu-item').find('.active').removeClass('active').find('.submenu-items').css({
                        display: 'none',
                        visibility: 'hidden',
                        opacity: '0',
                    })
                })

                module.on('mouseenter mouseleave', '.menu-products-submenu .submenu-items-group', function () {
                    $(this).addClass('active').siblings('.active').removeClass('active').find('.submenu-items').css({
                        display: 'none',
                        visibility: 'hidden',
                        opacity: '0',
                    })
                    $('.active').find('.submenu-items').css({
                        display: 'block',
                        visibility: 'visible',
                        opacity: '1',
                    })
                })
            }

            // Init backdrop cover
            const initBackdropAnim = () => {
                menuItem.hover(
                    function () {
                        hydrateSubmenu(this)
                        backdrop.css({ display: 'block', 'z-index': -1 })
                    },
                    function () {
                        backdrop[0].removeAttribute('style')
                    },
                )
            }

            // Init on resize browser window
            $(window).resize(function () {
                let windowWidth = window.innerWidth
                let breakpoint = 991
                module.removeClass('open')
                if (windowWidth > breakpoint) {
                    destroyMobileMenu()
                    createDesktopMenu()
                    removeMobileMenuHeight()
                } else {
                    destroyDesktopMenu()
                    // Slinky needs the full menu tree present to build its drill-down panels
                    hydrateAllSubmenus()
                    createMobileMenu()
                }
            })

            // Init desktop mega menu
            const createDesktopMenu = () => {
                setHeight(productsList)
                desktopMenu = true
            }

            // Destroys all inline styles added by js, on desktop view
            const destroyDesktopMenu = () => {
                if (desktopMenu) {
                    productsList.css({ height: 'auto' })
                    desktopMenu = false
                }
            }

            // Init Slinky mobile menu
            const createMobileMenu = () => {
                setMobileMenuHeight()
                if (mobileMenu == null) {
                    module.find('.js-auto-height').find('.active').removeClass('active')
                    mobileMenu = slinkyMenu.slinky({
                        title: true,
                    })
                }
            }

            // Destroys Slinky mobile menu
            const destroyMobileMenu = () => {
                if (mobileMenu != null) {
                    mobileMenu.destroy()
                    removeAllInlineStyles()
                    mobileMenu = null
                }
            }

            // On mobile, we have to set elements height for scrollbar
            const setMobileMenuHeight = () => {
                let deviceHeight = document.documentElement.clientHeight
                let mobileMenuHeader = module.find('.default-header')
                // .menu-footer only renders when the site has more than one language
                // (new-main-navigation.html.twig's `showLanguageDropdown` gate) - absent
                // entirely on single-language sites (e.g. cyesa-com).
                let footerHeight = mobileMenuFooter.length ? mobileMenuFooter[0].offsetHeight : 0
                let headerHeight = mobileMenuHeader.length ? mobileMenuHeader[0].offsetHeight : 0

                let treeHeight = deviceHeight - (headerHeight + footerHeight)

                module.find('.js-auto-height').each(function () {
                    $(this).height(treeHeight)
                    $(this).addClass('overflow-y-scroll')
                })
            }

            // When browser window is resized, then we have to remove inline styles and classes from element
            const removeMobileMenuHeight = () => {
                module.find('.js-auto-height').each(function () {
                    this.removeAttribute('style')
                    $(this).removeClass('overflow-y-scroll')
                })
            }

            // When browser window is resized, then we have to remove all inline styles added by Slinky plugin
            const removeAllInlineStyles = () => {
                let allMenuItems = module.find('ul')
                allMenuItems.each(function () {
                    this.removeAttribute('style')
                })
                removeMobileMenuHeight()
            }

            // Calculating mega menu height on desktop
            // Reads and writes are batched into two separate passes (read phase, then write
            // phase) instead of being interleaved, to avoid forcing a synchronous layout
            // reflow between them (LISXGPIM-1260, roadmap #33) — .root-item's height doesn't
            // depend on any of the writes below (its submenu siblings are position: absolute,
            // taken out of flow), so moving its read earlier doesn't change the result.
            const setHeight = (menu) => {
                const maxHeight = 792
                const measurements = []

                // Read phase — no .height(...) writes below this point
                menu.each(function () {
                    const minHeight = this.offsetHeight
                    const bgFillSelector = $(this).find('.bg-fill')
                    const rootItems = $(this).find('.root-item')
                    const menuProductsSubmenu = $(this).find('.menu-products-submenu')
                    const submenuItems = $(this).find('.submenu-items')
                    const menuGroupArticles = $(this).find('.menu-group-articles')
                    let outerHeight = 0

                    let newHeight = findHighestElement(this, minHeight)
                    if (newHeight > minHeight) {
                        newHeight = newHeight + 30
                    }

                    if (newHeight > maxHeight) {
                        newHeight = maxHeight
                    }

                    // Under menu bg-fill element height
                    rootItems.each(function () {
                        outerHeight += $(this).height()
                    })

                    measurements.push({
                        el: this,
                        newHeight,
                        bgFillSelector,
                        menuProductsSubmenu,
                        submenuItems,
                        menuGroupArticles,
                        outerHeight,
                    })
                })

                // Write phase — no layout reads below this point
                measurements.forEach(
                    ({ el, newHeight, bgFillSelector, menuProductsSubmenu, submenuItems, menuGroupArticles, outerHeight }) => {
                        $(el).height(newHeight)
                        menuProductsSubmenu.height(newHeight)
                        submenuItems.height(newHeight)
                        menuGroupArticles.height(newHeight)

                        let bgFillHeight = newHeight - outerHeight
                        if (bgFillHeight > 0) {
                            bgFillSelector.height(bgFillHeight)
                        }
                    },
                )
            }

            // Finding highest element in mega menu
            const findHighestElement = (elem, minHeight) => {
                let menuContent = $(elem).find('.js-auto-height')
                let newHeight = minHeight
                menuContent.each(function () {
                    if (this.offsetHeight > newHeight) {
                        newHeight = this.offsetHeight
                    }
                })
                return newHeight
            }

            // Click outside of main navigation
            $(document).on('click', (event) => {
                if (
                    !$(event.target).closest('.main-navigation > .container').length &&
                    !$(event.target).closest('.site-header .main-navigation-toggle button').length
                ) {
                    module.removeClass('open')
                }
            })

            // Mobile and Tablet dropdown functionality
            // Delegated (not a direct .click() on a cached selection) because the collapse-toggle arrows for
            // 2nd-level items (e.g. navigation-renderer.html.twig's submenu-header) live inside the
            // <template>-hydrated dropdown markup and don't exist in the live DOM until hydrateSubmenu() runs
            // on hover/tap — a direct binding made at this point would attach to nothing.
            module.on('click', '.main-navigation-items .collapse-toggle', function (e) {
                //close previous item
                let clickedArrow = $(this)
                let clickedDropdown = clickedArrow.closest('li').find('.dropdown')
                let prevDropdown = module.find('.collapse.show')
                let prevArrow = prevDropdown.parent().find('.collapse-toggle')
                closeCategory()

                e.preventDefault()
                if (clickedArrow[0] !== prevArrow[0]) {
                    clickedDropdown.collapse('show')
                    clickedArrow.removeClass('collapsed')
                }
            })

            const closeCategory = () => {
                let prevDropdown = module.find('.collapse.show')
                let prevArrow = prevDropdown.parent().find('.collapse-toggle')
                prevDropdown.collapse('hide')
                prevArrow.addClass('collapsed')
            }

            toggle.click(() => {
                // Slinky (mobile drill-down menu) is built lazily on first open, not on page load, so the deep
                // submenu templates stay out of the DOM until the visitor actually opens the mobile menu.
                if (Util.isMobile() && mobileMenu == null) {
                    hydrateAllSubmenus()
                    createMobileMenu()
                }
                module.toggleClass('open')
                $('#table_cart').toggleClass('z-index-1000')
            })

            if (Util.isMobile()) {
                module.find('.menu-group-articles').remove()
            } else {
                createDesktopMenu()
                initBackdropAnim()
                initMaintainHoverState()
            }

            // Delegated for the same reason as the collapse-toggle handler above: .simple-menu (the
            // navigation-renderer/brands-navigation dropdown) is hydrated from a <template> on demand, so a
            // cached `body.find('.simple-menu')` selection made at init time would never match it.
            module.on('mouseleave', '.simple-menu', closeCategory)
        }
    })
})(jQuery)
